import injectRegistrationScripts, {
  injectDefaultScripts,
} from './registrationScripts';
import './basic';

import toggleCookieBanner from './components/cookie-banner';

function injectOnView() {
  if (window.scrollY >= 300 || window.location.pathname === '/ca/lp/answering-service-social') {
    injectRegistrationScripts();
    injectDefaultScripts();
  }
}

window.addEventListener('load', () => {
  injectOnView();
  toggleCookieBanner();
});
document.addEventListener('scroll', () => {
  injectOnView();
});
